import { useQuery } from '@tanstack/react-query';
import { bulkMoveAccounts } from "../orgPanelApiCalls";

const key = 'moveSelected';

const useMoveSelectedQuery = (destinationAccount, accountList) => {
    return useQuery({ queryKey: [key], queryFn: () => bulkMoveAccounts(destinationAccount, accountList)})
}

export { useMoveSelectedQuery, key };
